import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Report2 extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get financialResultIncome() {
    try {
      return JSON.parse(
        get(this, '_wyniki_finansowe_w_latach_przychod.value', '')
      );
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }
  get financialResultProfitLoss() {
    try {
      return JSON.parse(
        get(this, '_wyniki_finansowe_w_latach_zysk_strata.value', '')
      );
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }

  get period() {
    return get(this, '_kwartal.value[0].codename', '');
  }

  get year() {
    return get(this, '_rok.value', '');
  }

  get quarter() {
    let quarter = get(this, '_kwartal.value[0].name', '');
    switch (quarter) {
      case 'Q1':
        quarter = '1';
        break;
      case 'Q2':
        quarter = '2';
        break;
      case 'Q3':
        quarter = '3';
        break;
      case 'Q4':
        quarter = '4';
        break;
      default:
        quarter = 'Roczny';
    }
    return quarter;
  }

  get reportImage() {
    return get(this, '_miniaturka.value[0].url', '');
  }

  get prevYear() {
    return this.year - 1;
  }

  get nextYear() {
    return this.year + 1;
  }

  get pdfUrl() {
    return get(this, '_raport_pdf.value', '[]');
  }

  get videoComment() {
    return get(this, '_komentarz_video.value[0]', {});
  }

  get videoPoster() {
    return get(this, '_komentarz_video[0].plakat_filmu.value[0].url', '');
  }

  get videoLink() {
    return get(this, '_komentarz_video[0].link_do_filmu.value', '');
  }

  get historyOfCapitalGroupEvents() {
    return get(this, '_historia_grupy_kapitalowej.value', []);
  }

  get relevantEvents() {
    return get(this, '_wydarzenia.value', []);
  }

  get incomeTabOneComment() {
    return get(this, '_przychody_wg_dzialalnosci___komentarz.value[0]');
  }

  get incomeTabOneChartData() {
    return get(this, '_przychody_wg_dzialalnosci___wykres.value');
  }

  get incomeTabTwoComment() {
    return get(this, '_przychody_wg_sektorow___komentarz.value[0]');
  }

  get incomeTabTwoChartData() {
    return get(this, '_przychody_wg_sektorow___wykres.value');
  }

  get incomeTabThreeComment() {
    return get(this, '_przychody_wg_spolek___komentarz.value[0]', '');
  }

  get incomeTabThreeChartData() {
    return get(this, '_przychody_wg_spolek___wykres.value');
  }

  get incomeTabFourComment() {
    return get(this, '_przychody_wg_kraju_pochodzenia___komentarz.value[0]');
  }

  get incomeTabFourChartData() {
    return get(this, '_przychody_wg_kraju_pochodzenia___wykres.value');
  }

  get forecastsAndPlansText() {
    return get(this, '_prognozy_i_plany.value', '');
  }

  get forecastsAndPlansChartData() {
    return get(this, '_prognozy_wykres.value');
  }

  get mainIncomeSources() {
    return get(this, '_zrodla_przychodu.value', []);
  }

  get shareholdersStructureChartData() {
    return get(this, '_struktura_akcjonariatu___wykres.value');
  }

  get shareholdersStructureData() {
    try {
      return JSON.parse(get(this, '_struktura_akcjonariatu.value'));
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }

  get capitalStructureData() {
    try {
      return JSON.parse(get(this, '_struktura_kapitalu_dane.value'));
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }

  get capitalStructureText() {
    return get(this, '_struktura_kapitalu.value', '');
  }

  get consolidatedFinancialReportLink() {
    return get(this, '_sprawozdanie_finansowe_zalacznik.value[0].url', '');
  }
  get consolidatedFinancialReportAssetsData() {
    try {
      return JSON.parse(get(this, '_aktywa.value', ''));
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }
  get consolidatedFinancialReportAssetsFile() {
    return get(this, '_sprawozdanie_finansowe___aktywa.value[0].url', '');
  }
  get consolidatedFinancialReportLiabilitiesData() {
    try {
      return JSON.parse(get(this, '_pasywa.value', ''));
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }
  get consolidatedFinancialReportLiabilitiesFile() {
    return get(this, '_sprawozdanie_finansowe___pasywa.value[0].url', '');
  }
  get consolidatedFinancialReportConsolidatedProfitAndLossData() {
    try {
      return JSON.parse(
        get(this, '_skonsolidowany_rachunek_zyskow_i_strat.value', '')
      );
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }

  get consolidatedFinancialReportConsolidatedProfitAndLossFile() {
    return get(this, '_sprawozdanie_finansowe___zyski_straty.value[0].url', '');
  }

  get consolidatedFinancialReportConsolidatedFinancialStatementData() {
    try {
      return JSON.parse(
        get(this, '_zestawienie_zmian_w_skonsolidowanym_kapitale.value', '')
      );
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }

  get consolidatedFinancialReportConsolidatedFinancialStatementFile() {
    return get(
      this,
      '_sprawozdanie_finansowe___zestawienie_zmian.value[0].url',
      ''
    );
  }
  get consolidatedFinancialReportConsolidatedAccountData() {
    try {
      return JSON.parse(
        get(this, '_skonsolidowany_rachunek_przeplywow_pienieznych.value', '')
      );
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }
  get consolidatedFinancialReportConsolidatedAccountFile() {
    return get(
      this,
      '_sprawozdanie_finansowe___rachunek_przeplywow.value[0].url',
      ''
    );
  }

  get basicRisksAndThreatsDescription() {
    return get(this, '_zagrozenia.value', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/Report2.js